import DocumentReview from '@/pages/DocumentReviewPage';
import EscalationIssueHeading from './EscalationIssueHeading';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { SINGLE_TASK_QUERY } from '@/graphql/queries/record-management';
import { useEffect, useState } from 'react';
import ValidateReport from '@/pages/ValidateReport';
import { Escalation } from '@/types/doctorManagementTypes';
import { taskQueryBusinessStatus } from '@/constants';
import { transformEscalationData } from '@/lib/utils';

export default function EscalationIssue() {
  const [isReviewer, setIsReviewer] = useState<boolean>(() => {
    const storedReviewer = localStorage.getItem('isReviewer');
    return storedReviewer ? JSON.parse(storedReviewer) : false;
  });  const [escalationData, setEscalationData] = useState<Escalation>();
  const [isDataProcessed, setIsDataProcessed] = useState(false);  
  const { ticketNo } = useParams<{ ticketNo: string }>();
  const { data, loading } = useQuery(SINGLE_TASK_QUERY, {
    variables: { id: ticketNo },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  useEffect(() => {
    if (!loading && data) {
      const task = data?.primary?.[0];

      const reviewerStatusCodes = [
        taskQueryBusinessStatus.documentSupervisorBusinessStatus[0], // Review in-progress
        taskQueryBusinessStatus.documentSupervisorBusinessStatus[1], // Validation in-progress
        taskQueryBusinessStatus.documentSupervisorFallbackBusinessStatus[0], // Review escalated
        taskQueryBusinessStatus.documentSupervisorFallbackBusinessStatus[1], // Validation escalated
      ];

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const isReviewer = task?.businessStatus?.coding.some((coding: any) =>
        reviewerStatusCodes.includes(coding.code)
      );

      setIsReviewer(!!isReviewer);
      localStorage.setItem('isReviewer', JSON.stringify(!!isReviewer));

      const transformedData = transformEscalationData(data?.primary);
      setEscalationData(transformedData[0]);
      setIsDataProcessed(true);
    }
  }, [data, loading]);

  if (loading || !isDataProcessed) return null;

  return (
    <div
      className="overflow-y-scroll p-8 h-full"
      style={{ background: '#fff' }}
    >
      <EscalationIssueHeading data={escalationData} />
      {isReviewer ? (
        <DocumentReview
          showHeader={false}
          showIcons={false}
          isSupervisor={true}
          escalatedData={data?.primary?.[0]}
          otherData={escalationData}
        />
      ) : (
        <ValidateReport showHeader={false} isSupervisor={true} escalatedData={data?.primary?.[0]} description={escalationData?.description} />
      )}
    </div>
  );
}
